<template>
  <Login2
    :show-dialog="showDialog"
    :show-login="showLogin"
    :show-mobile="showMobile"
    @update:show-dialog="onLoginDialogChange"
  />

  <div class="ni-site-layout" :class="layoutClass">
    <template v-if="layout === 'hero-overlay'">
      <div class="ni-site-hero">
        <slot name="hero" />
        <NewIndexHeader
          mode="site"
          :theme="theme"
          :hero-overlay="layout === 'hero-overlay'"
          :show-search="showHeaderSearch"
          :show-lang="showHeaderLang"
          :is-logged-in="isLoggedIn"
          :username="username"
          @search="handleSearch"
          @login="openLogin"
        />
      </div>
      <slot name="subnav" />
      <div class="ni-site-main">
        <slot />
      </div>
    </template>

    <template v-else>
      <NewIndexHeader
        mode="site"
        :theme="theme"
        :show-search="showHeaderSearch"
        :show-lang="showHeaderLang"
        :is-logged-in="isLoggedIn"
        :username="username"
        @search="handleSearch"
        @login="openLogin"
      />
      <div v-if="$slots.hero" class="ni-site-hero ni-site-hero--stacked">
        <slot name="hero" />
      </div>
      <slot name="subnav" />
      <div class="ni-site-main">
        <slot />
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Login2 from '@/components/common/login2.vue';
import NewIndexHeader from '@/components/newIndex/NewIndexHeader.vue';
import { resolveSiteHeaderConfig } from '@/config/newIndexNav.js';
import { useNewIndexSite } from '@/composables/useNewIndexSite.js';

const props = defineProps({
  layout: {
    type: String,
    default: '',
  },
  theme: {
    type: String,
    default: '',
  },
  showHeaderSearch: {
    type: Boolean,
    default: null,
  },
  showHeaderLang: {
    type: Boolean,
    default: null,
  },
});

const route = useRoute();

const {
  showDialog,
  showLogin,
  showMobile,
  isLoggedIn,
  username,
  onLoginDialogChange,
  openLogin,
  handleSearch,
} = useNewIndexSite();

const resolvedConfig = computed(() => {
  const fromRoute = resolveSiteHeaderConfig(route.path);
  return {
    layout: props.layout || fromRoute.layout,
    theme: props.theme || fromRoute.theme,
    showHeaderSearch: props.showHeaderSearch ?? fromRoute.showHeaderSearch,
    showHeaderLang: props.showHeaderLang ?? fromRoute.showHeaderLang,
  };
});

const layout = computed(() => resolvedConfig.value.layout);
const theme = computed(() => resolvedConfig.value.theme);
const showHeaderSearch = computed(() => resolvedConfig.value.showHeaderSearch);
const showHeaderLang = computed(() => resolvedConfig.value.showHeaderLang);

const layoutClass = computed(() => [
  `ni-site-layout--${layout.value}`,
  `ni-site-layout--${theme.value}`,
]);
</script>

<style src="@/assets/css/new_index_header.css"></style>
